/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drastic_Tech_Mode_LabelInputs */



/**
* | output |
* | --- |
* | "Mode" |
*
* @param {Drastic_Tech_Mode_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_mode_label = /** @type {((inputs?: Drastic_Tech_Mode_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Mode_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mode")
	if (locale === "de") return /** @type {LocalizedString} */ ("Modus")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modalità")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Режим")
	if (locale === "es") return /** @type {LocalizedString} */ ("Modo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("模式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("モード")
	if (locale === "hi") return /** @type {LocalizedString} */ ("तरीका")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Modo")
	return /** @type {LocalizedString} */ ("Mode")
});